import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { ToastService } from "@app/modules/shared/services/message/toast.service";
import { BaseForm } from "@app/data/shared/models/base-form.interface";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { UtilService } from "@app/modules/shared/services/util.service";
import { SpeCodeDto } from "@dashboard/modules/application-params/specode/model/specode.dto";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";

@Component({
  selector: "kl-new-special-code",
  templateUrl: "./specode-form.component.html",
})
export class SpeCodeFormComponent
  implements OnInit, AfterViewInit, OnDestroy, BaseForm
{
  @ViewChild("MaterialSpeCodeForm", { static: true })
  private materialSpeCodeForm;
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  @Input() entity: SpeCodeDto = new SpeCodeDto();
  @Input() isReadOnly: boolean;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  @Input() mode: string;
  typeOptions = [
    {
      label: this.translateService.instant("MATERIAL_CARD"),
      value: "MATERIAL_CARD",
    },
    {
      label: this.translateService.instant("CURRENT_ACCOUNT_CARD"),
      value: "CURRENT_ACCOUNT_CARD",
    },
  ];
  title = "";
  alertShow: boolean;
  alertType: string;
  alertMessage: any;
  saveForm = false;
  isOpen = true;

  constructor(
    private apiService: ApiService,
    private explorerService: ExplorerService,
    private utilService: UtilService,
    private translateService: TranslateService,
    private klLoading: KlLoadingService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    if (this.mode === "add") {
      this.entity.type = "MATERIAL_CARD";
      this.title =
        this.translateService.instant("new") +
        " " +
        this.translateService.instant("special_code");
    }
    if (this.mode === "view" || this.mode === "edit") {
      this.title = this.translateService.instant("special_code") + " - ";
    }
    this.klLoading.hide();
  }

  ngAfterViewInit() {
    this.elementFocus.nativeElement.focus();
  }

  clearForm() {
    this.elementFocus.nativeElement.focus();
    Object.keys(this.entity).forEach((o) => {
      if (o !== "type") {
        delete this.entity[o];
      }
    });
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  commitSave(action: any) {
    if (this.materialSpeCodeForm.valid) {
      this.klLoading.show("saving");
      this.saveForm = true;
      switch (action) {
        case "SAVE":
          switch (this.mode) {
            case "add":
              this.apiService.addData("specode", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
            case "edit":
              this.apiService.updateData("specode", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
          }
          break;
        case "SAVE_NEW":
          this.apiService.addData("specode", this.entity).subscribe(
            (response) => this.handleNew(response),
            (error) => this.handleError(error)
          );
          break;
      }
    } else {
      this.handleError("required_fields_must_be_entered");
    }
  }

  handleResponse(response) {
    this.klLoading.hide();
    this.toastService.toastSuccess();
    if (this.tabId) {
      this.formChange(false);
      this.explorerService.closeTab(this.tabId);
    } else if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleNew(response) {
    this.alertShow = false;
    this.saveForm = false;
    this.formChange(false);
    this.toastService.toastSuccess();
    this.klLoading.hide();
    this.clearForm();
  }

  handleError(error) {
    this.alertShow = true;
    this.saveForm = false;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoading.hide();
  }

  unlockEntity() {
    this.apiService.unlockData("specode", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
  }
}
